import FlatButton from 'material-ui/FlatButton';
import React, { PropTypes } from 'react';
import styled from 'styled-components';
import Breakpoint from '../../../utils/breakpoints';
import ProductImage from '../../../assets/images/login/nitro_main_desktop.png';
import ProductImageMobile from '../../../assets/images/login/nitro_main_mobile.png';
import { media } from '../../../utils/style-utils';

const Row = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
`;

const Column = styled.div`
  box-sizing: border-box;
  padding: 0 30px;
  display: flex;
  flex-direction: column;
  width: 50%;
  min-width: 329px;
  align-items: start;
  justify-content: center;
  margin-bottom: 20px;
`;

const Header = styled.span`
  color: #fff;
  font-size: 24px;
  margin: 28px 0 14px;
`;

const Body = styled.span`
  color: #fff;
`;
const ProductImg = styled.img`
  width: 100%;
  padding-right: 8px;

  ${media.mobile`
    padding-right: 0px;
  `};
`;

const Product = styled.div`
  width: 100%;
  max-width: 800px;
  padding-right: 40px;

  ${media.mobile`
    margin-top: 20px;
    padding-right: 0;
  `};

  ${media.tablet`
    margin-top: 20px;
    padding-right: 0;
  `};
`;

const StyledButton = styled(FlatButton)`
  color: #616161 !important;

  &:hover {
    color: #fff !important;
  }

  &:not(:first-of-type) {
    margin-left: 27px !important;

    ${media.mobile`
      margin-left: 13px!important;
      margin-right: 13px!important;
    `};
  }

  ${media.mobile`
    margin: 0 13px!important;
  `};
`;

const ButtonLabel = styled.span`
  font-size: 11px;
  font-family: ${props => props.theme.font.bold};
`;

const ActionsBar = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-top: 20px;
  width: 100%;
`;

class LoginHero extends React.Component {
  // eslint-disable-next-line class-methods-use-this
  onScroll(id) {
    const el = window.document.getElementById(id);
    el.scrollIntoView({ behavior: 'smooth' });
  }

  render() {
    return (
      <div>
        <Row>
          <Column style={{ width: '450px' }}>
            <Header>Get better insights on your fleet</Header>
            <Body>
              With Nitro, you can view and manage your fleet, drivers and costs
              all in one place. You can get a holistic view of all your
              fleet-related data to gain valuable insights and visibility of how
              it’s tracking.
            </Body>
            <ActionsBar>
              <StyledButton
                id="demoButton"
                onClick={() => this.onScroll(this.props.demoElId)}
                disableTouchRipple
                backgroundColor="white"
              >
                <ButtonLabel>DEMO</ButtonLabel>
              </StyledButton>
            </ActionsBar>
          </Column>
          <Column>
            <Product>
              <Breakpoint name="tabletDesktop">
                <ProductImg src={ProductImage} alt="Product" />
              </Breakpoint>
              <Breakpoint name="mobile">
                <ProductImg src={ProductImageMobile} alt="Product" />
              </Breakpoint>
            </Product>
          </Column>
        </Row>
      </div>
    );
  }
}

LoginHero.propTypes = {
  demoElId: PropTypes.string.isRequired
};

export default LoginHero;



// WEBPACK FOOTER //
// ./src/features/login/login-hero/LoginHero.js